import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    layout: 'index-layout',
    isBlocked: false,
    isMobile: false,
    activeRequests: 0,
    drawer: false,
    mensagem: {},
    confirmacao: {},
    loading: false,
    gridButtom: {},
    gridCheckbox: {},
    situacaoCirculo:{}
  },
  mutations: {
    isMobile (state) {
      state.isMobile = window.innerWidth < 960
    },
    addRequest (state) {
      state.activeRequests += 1
    },
    removeRequest (state) {
      state.activeRequests -= 1
      if (state.activeRequests < 0) { state.activeRequests = 0 }
    },
    SET_USER_DATA (state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.setItem('status', 'loggedIn')
      axios.defaults.headers.common['Authorization'] = `Bearer ${
        userData.token
      }`
      
      window.dispatchEvent(new CustomEvent('status-changed', {
        detail: {
          storage: localStorage.getItem('status')
        }
      }
      ))
    },
    CLEAR_USER_DATA () {
      localStorage.removeItem('user')
      localStorage.removeItem('challenge')
      localStorage.setItem('status', 'loggedOut')

      window.dispatchEvent(new CustomEvent('status-changed', {
        detail: {
          storage: localStorage.getItem('status')
        }
      }
      ))
      location.reload();
    },
    LIMPAR_CHALLENGE(){
      localStorage.removeItem('challenge')
    },
    SET_LAYOUT (state, payload) {
      state.layout = payload
    },
    confirmacao (state, obj) {
      state.confirmacao = obj
    },
    mensagem (state, obj) {
      state.mensagem = obj
    },
    close (state) {
      state.confirmacao.show = false
    },
    closeMessage (state) {
      state.mensagem.show = false
    },
    loading (state, obj) {
      state.loading = obj
    },
    gridButtom (state, obj) {
      state.gridButtom = obj
    },
    gridCheckbox (state, obj) {
      state.gridCheckbox = obj
    },
    situacaoCirculo (state, obj) {
      state.situacaoCirculo = obj
    }
  },
  actions: {
    setUserData ({ commit }, data) {
      commit('SET_USER_DATA', data)
    },
    logout ({ commit }) {
      commit('CLEAR_USER_DATA')
    },
    limparChallenge ({ commit }) {
      commit('LIMPAR_CHALLENGE')
    }
  },
  getters: {
    isMobile (state) {
      return state.isMobile
    },
    activeRequests (state) {
      return state.activeRequests
    },
    layout (state) {
      return state.layout
    },
    loggedIn (state) {
      return !!state.user
    },
    confirmacao (state) {
      return state.confirmacao
    },
    mensagem (state) {
      return state.mensagem
    },
    loading (state) {
      return state.loading
    },
    gridButtom (state) {
      return state.gridButtom
    },
    gridCheckbox (state) {
      return state.gridCheckbox
    },
    situacaoCirculo (state) {
      return state.situacaoCirculo
    },
    money () {
      return { precision: 2, decimal: ',', thousands: '.', prefix: '', suffix: '', masked: false, maxlength: 20 }
    }
  }
})
